// extracted by mini-css-extract-plugin
module.exports = {"large":"PageHeader_large__2c9WH","small":"PageHeader_small__3Ocyt","none":"PageHeader_none__3lhm-","menuButton":"PageHeader_menuButton__38k7j"};